import Environment from '../environment';
import { getLogger } from '../logging/logger';
import gsap from './hwpTVGSAP';

const logger = getLogger('buttonGSAPEffects');

export const BUTTON_EFFECTS = Object.freeze({
	focus: 'btnFocus',

	// click
	down: 'btnDown',
	up: 'btnUp',

	incorrect: 'btnIncorrect',
});

gsap.registerEffect({
	name: BUTTON_EFFECTS.focus,
	effect: ([button]) => {
		logger.log('[focus]', { button });

		return gsap.timeline().fromTo(
			button,
			{
				scale: 1,
			},
			{
				scale: 1.05,
				duration: 0,
			},
		);
	},
	extendTimeline: true,
});

gsap.registerEffect({
	name: BUTTON_EFFECTS.down,
	effect: ([button]) => {
		logger.log('[down]', { button });

		const offset = button.style.getPropertyValue('--btn-layer-offset') || '0.5vmin';
		const offsetValue = parseFloat(offset);
		const y = offset;
		const x = `-${offsetValue * 0.2}vmin`;

		return gsap.timeline().to(button.children, {
			y,
			x,
			filter: ' brightness(0.7)',
			duration: 0,
		});
	},
	extendTimeline: true,
});

gsap.registerEffect({
	name: BUTTON_EFFECTS.up,
	effect: ([button]) => {
		logger.log('[up]', { button });

		return gsap.timeline().to(button.children, {
			y: 0,
			x: 0,
			filter: 'brightness(1)',
			duration: 0,
		});
	},
	extendTimeline: true,
});

gsap.registerEffect({
	name: BUTTON_EFFECTS.incorrect,
	effect: ([button]) => {
		logger.log('[incorrect]', { button });

		if (Environment.isVerizon1100()) {
			return gsap.timeline().to(button, {});
		}

		return gsap.timeline().to(
			button,
			{
				keyframes: {
					x: [
						'-1vmin',
						'2vmin',
						'-4vmin',
						'4vmin',
						'-4vmin',
						'4vmin',
						'-4vmin',
						'2vmin',
						'-1vmin',
						'0', // start
					],
				},
				duration: 1,
			},
			'<',
		);
	},
	extendTimeline: true,
});

export default gsap;
